import './App.css';
import Home from './components/Home';

function App() {
  return (
    <div className="bg-[#9368332a] min-h-screen p-8">
      <Home />
    </div>
  );
}

export default App;
